<template>
  <div class="plan-free-user">
    <div class="user-actions">
      <div class="plan">
        <p>Free Trial</p>
      </div>
      <div class="days-left">
        <p> <span>{{user.remainingSearches}}</span> searches left</p>
        <p>Member since <span> {{ this.getDate(user.createdAt) }} </span></p>
      </div>
    </div>
    <router-link class="orange-btn" to="/pricing-plan">
      <a>Upgrade Your Plan</a>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['user'],

  data() {
    return {
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"],
    }
  },

  methods: {
    getDate(date) {
      let fullDate = new Date(date);
      let d = fullDate.getDate();
      let m = this.months[fullDate.getMonth()];
      let y = fullDate.getFullYear();
      return `${m} ${d}, ${y}`;
    }
  }
}
</script>

<style lang="scss">
  .plan-free-user {
    display: flex;
    justify-content: space-between;

    .user-actions {
      display: flex;
      justify-content: space-between;
      width: 350px;

      p {
        margin: 0;
        color: #676868;
      }

      .plan {
        margin-right: 10%;
      }
    }

    .orange-btn {
      padding: 0 60px;
    }
  }
</style>